import { useEffect, useState } from "react";
import { fetchPromises, fetchParties } from "@/lib/api";
import Seo from "@/components/Seo";
import PromiseCard from "@/components/PromiseCard";

const STATUSES = [
    { value: "", label: "Alle statusser" },
    { value: "holdt", label: "Holdt" },
    { value: "brudt", label: "Brudt" },
    { value: "delvist", label: "Delvist holdt" },
    { value: "afventer", label: "Afventer" },
];

export default function Promises() {
    const [promises, setPromises] = useState([]);
    const [parties, setParties] = useState([]);
    const [partyId, setPartyId] = useState("");
    const [status, setStatus] = useState("");

    useEffect(() => {
        fetchParties().then(setParties);
    }, []);

    useEffect(() => {
        const params = {};
        if (partyId) params.party_id = partyId;
        if (status) params.status = status;
        fetchPromises(params).then(setPromises);
    }, [partyId, status]);

    const partiesById = Object.fromEntries(parties.map((p) => [p.id, p]));

    return (
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-testid="promises-page">
            <Seo
                title="Løftedatabase — alle valgløfter"
                description="Samlet database over danske politikeres valgløfter — holdte, brudte, delvist indfriede og afventende. Filtrer på parti, kategori og sværhedsgrad."
                keywords="valgløfter, løftedatabase, valgflæsk, løftebrud, politiske løfter, Folketinget, regering"
                path="/lofter"
            />
            <div className="mb-10">
                <span className="text-xs uppercase tracking-[0.2em] text-[#4F5A7A] font-semibold">
                    Løftedatabase
                </span>
                <h1 className="font-serif-dm text-5xl text-royal mt-2">
                    Alle danske valgløfter
                </h1>
                <p className="text-[#4F5A7A] mt-3 max-w-2xl">
                    Gennemse alle registrerede politiske løfter. Filtrér efter parti og
                    status for at finde præcis det, du leder efter.
                </p>
            </div>

            <div className="flex flex-col md:flex-row gap-4 mb-8">
                <select
                    value={partyId}
                    onChange={(e) => setPartyId(e.target.value)}
                    className="px-5 py-3 border border-[#E5E8F0] rounded-full text-sm bg-white focus:outline-none focus:border-royal flex-1"
                    data-testid="promise-filter-party"
                >
                    <option value="">Alle partier</option>
                    {parties.map((p) => (
                        <option key={p.id} value={p.id}>
                            {p.name}
                        </option>
                    ))}
                </select>
                <select
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    className="px-5 py-3 border border-[#E5E8F0] rounded-full text-sm bg-white focus:outline-none focus:border-royal flex-1"
                    data-testid="promise-filter-status"
                >
                    {STATUSES.map((s) => (
                        <option key={s.value} value={s.value}>
                            {s.label}
                        </option>
                    ))}
                </select>
            </div>

            <div className="text-sm text-[#4F5A7A] mb-5" data-testid="promises-count">
                Viser {promises.length} løfter
            </div>

            <div className="grid md:grid-cols-2 gap-4">
                {promises.map((p) => {
                    const party = partiesById[p.party_id];
                    return (
                        <PromiseCard
                            key={p.id}
                            promise={p}
                            partyName={party?.name}
                            partyColor={party?.color}
                        />
                    );
                })}
            </div>
            {promises.length === 0 && (
                <div className="text-center py-20 text-[#4F5A7A]">
                    Ingen løfter matcher dit filter.
                </div>
            )}
        </div>
    );
}
